
import { GenericResponse } from "./Generic";
export enum APIContext {
  Residential = "residential",
  SmallBusiness = "smallBusiness",
}

export type CreateSessionResponse = GenericResponse & {
  message?: string;
  token: string;
  brazeId?: string | null;
  ip?: string;
  context: APIContext;
};

export type DestroySessionResponse = GenericResponse;

export type BrazeIdResponse = GenericResponse & {
  brazeId: string[];
};

export type AddressUnit = {
  addressLine2: string;
  dfAddressId: string;
};

export type AddressLabelName =
  | "addressLine1"
  | "addressLine2"
  | "city"
  | "state"
  | "postalCode";

export type Address = {
  zip4?: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  postalCode: string;
  telephone?: string;
  dfAddressId?: string;
  fullAddress?: string;
  units?: AddressUnit[];
};

export interface PartialParsedAddress extends Partial<Address> {}

export type SetAddressBody = Address | Pick<Address, "dfAddressId">;

export type SetServiceAddress = {
  geoPrecision: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  stateProvinceCd: string;
  postalCd: string;
  geoLat: string;
  geoLong: string;
  addrStndNbr: string;
  addrStndStreetNm: string;
  addrStndStreetSuffix: string;
  exchangeId: string;
  addressCatalogDt: string;
  censusBlock: string;
  competitorCompanyName: string;
  competitorQualSpeed: string;
  competitorTechName: string;
  maxQualDropFlag: string;
  maxQualFinalExchange: string;
  maxQualTechnologyType: string;
  maxQualTermDistanceInFeet: string;
  mduId: string;
  zip4?: string;
};

export enum ValidationResultTypes {
  WAITING = "Waiting",
  EXISTING_CUSTOMER = "ExistingCustomer",
  ADDRESS_FOUND = "AddressFound",
  ADDRESS_FOUND_COPPER = "AddressFoundCopper",
  ADDRESS_NOT_FOUND = "AddressNotFound",
  ADDRESS_DOES_NOT_QUALIFY_FOR_SERVICE = "AddressDoesNotQualifyForService",
  ADDRESS_DOES_NOT_QUALIFY = "AddressDoesNotQualifyForService",
  ZIPCODE_WITHIN_FOOTPRINT = "ZipCodeWithinFootprintNotFound",
  UQUAL_NOT_REACHABLE = "UqualNotReachable",
  UQUAL_DB_NOT_REACHABLE = "UQualDbNotReachable",
  ADDRESS_NEED_FIX = "AddressNeedsFix",
  ADDRESS_NOT_QUALIFIED = "AddressDoesNotQualifyForService",
  ADDRESS_NOT_FOUND_IN_TERRITORY = "AddressNotFoundInTerritory",
}

type VoipOption = "M" | "F" | "N" | "S" | "Y";

export type SetServiceAddressResponse = GenericResponse & {
  accessId: string;
  dfAddressId: string;
  techType: string;
  address: SetServiceAddress;
  exchangeId: string;
  street: string;
  streetAddress: string;
  validationResult: ValidationResultTypes;
  maxQual: string;
  exactMatch: boolean;
  fiberFastFlag: boolean;
  addressCandidates: Address[];
  wildcardMode: boolean;
  scoreMetFlag: boolean;
  broadbandService: {
    finalVoip: VoipOption;
    finalQualSpeed: string;
    finalExpectedSpeedUp: string;
  };
  tier: string;
  errorMessage?: string;
  vdsl2AmpEligible: boolean;
  // the shape of this property isn't stable and depends on the underlying error
  overRides?: unknown[];
};
